module.exports = __webpack_public_path__ + "static/media/icon.dbf0ae4f.png";